import { clickupService } from "@/services/clickupService";
import type { Agent } from "@/types/aiToolkit";

export function agentCanUseClickUpWrite(agent: Agent | null | undefined): boolean {
  if (!agent) return false;
  const hasCap = agent.capabilityModules?.includes("cap-clickup-write");
  const hasTool = agent.allowedToolIds?.includes("clickup");
  return Boolean(hasCap && hasTool);
}

/** Verify ClickUp API is reachable for the current user session. */
export async function ensureClickUpConnected(): Promise<boolean> {
  try {
    await clickupService.listTeams();
    return true;
  } catch {
    return false;
  }
}
